import { Component, h, useRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";

import classes from './AnimatedFeatureList.module.css';

export const AnimatedFeatureList = () => {
  return h(html.ol, { className: classes.animatedFeatureList }, [
    h(AnimatedFeatureCard, {  }, h(WIPFeature)),
    //h(AnimatedFeatureCard, {  }, 'Sorry, no features yet!'),
  ]);
}

const WIPFeature = () => {
  return [
    h(html.h4, {}, 'Work in Progress'),
    h(html.p, {}, `Sorry, no more features for now. Kosmod is in active development, check back in soon to see what gets added!`)
  ]
}


export const AnimatedFeatureCard: Component = ({ children }) => {
  const inputSourceRef = useRef<HTMLLIElement | null>(null);
  const rotationTargetRef = useRef<HTMLDivElement | null>(null);

  const onMouseMove = (e: MouseEvent) => {
    const li = inputSourceRef.get()!;
    const target = rotationTargetRef.get()!;

    const rect = li.getBoundingClientRect();

    const x = (e.offsetX - (rect.width / 2)) / rect.width;
    const y = (e.offsetY - (rect.height / 2)) / rect.width;

    target.style.transform = `perspective(50px) translateY(-12px) scale(1.05) rotateY(${x * 2}deg) rotateX(${-y * 2}deg)`
  }
  const onMouseLeave = (e: MouseEvent) => {
    const target = rotationTargetRef.get()!;
    target.style.transform = ``
  }

  return h(html.li, { className: classes.animatedFeatureContainer, onMouseMove, onMouseLeave, ref: inputSourceRef }, [
    h(html.div, { className: classes.animatedFeatureCard, ref: rotationTargetRef }, children)
  ]);
}